import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58bcc7ce&scoped=true&"
import script from "./composition.js?vue&type=script&lang=js&"
export * from "./composition.js?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=58bcc7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bcc7ce",
  null
  
)

export default component.exports